import { render, staticRenderFns } from "./DetailsCourseAddEditSubjectModal.vue?vue&type=template&id=4ca23ce8&scoped=true&"
import script from "./DetailsCourseAddEditSubjectModal.vue?vue&type=script&lang=js&"
export * from "./DetailsCourseAddEditSubjectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca23ce8",
  null
  
)

export default component.exports